import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import navigation from '../navigation';

import BreadCrumbs from '../partials/BreadCrumbs';

class AboutUs extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
/*
                <Banner images={Session.getBannerPictures(Session.model.aboutUs.banner)}
                    title={Session.model.aboutUs.slogan1}
                    text={Session.model.aboutUs.slogan2}
                />*/
            <BasePage data={Session.model.aboutUs}>
                <BreadCrumbs fullpath={window.location.pathname} name={""} />
                <i.Container>
                    <i.Row>
                        <i.Col align="left">
                            <div>{i.markdown(Session.model.aboutUs.text)}</div>
                        </i.Col>
                    </i.Row>
                </i.Container>
            </BasePage>
        );
    }
}

export default AboutUs;